import type { ClassValue } from 'clsx'
import { clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// tailwind-merge files unknown text-* values under text colour, so without this a
// `text-kpi-*` or `text-mono-*` size next to a colour class drops one of the two.
const isCustomFontSize = (value: string) => /^(?:kpi|mono)-[a-z0-9]+$/.test(value)

// register custom utilities here so cn knows about them and respects overrides
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-family': ['text-numeric'],
      'font-size': [{ text: [isCustomFontSize] }],
    },
  },
})

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
